var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudyLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.152,
    height: 20.152,
    viewBox: "0 0 20.152 20.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16630",
    "data-name": "Group 16630",
    transform: "translate(-2273 -2950)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2058",
    "data-name": "Rectangle 2058",
    width: 20.152,
    height: 20.152,
    transform: "translate(2273 2950)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16629",
    "data-name": "Group 16629",
    transform: "translate(-47.309 224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M108.2,269.663v3.653a1.065,1.065,0,0,1-1.064,1.064H97.984a1.065,1.065,0,0,1-1.064-1.064v-3.653l4.738,2.148a2.177,2.177,0,0,0,1.8,0Z",
    transform: "translate(2227.825 2466.613)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M18.146,41.02a1.1,1.1,0,0,0-.642-.951L9.546,36.356a1.114,1.114,0,0,0-.944,0L.644,40.069A1.117,1.117,0,0,0,.655,42.1l7.958,3.608a1.116,1.116,0,0,0,.922,0l7.553-3.424V51.3a.532.532,0,0,0,1.064,0C18.151,40.331,18.154,41.079,18.146,41.02Z",
    transform: "translate(2321.309 2691.749)",
    fill: "#3f2566"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudyLevel);
export default __webpack_public_path__ + "static/media/study_level.7a88387ae943aa91d3b9e0dfba77f892.svg";
export { ForwardRef as ReactComponent };